// The plumbing every ported Insights page shares, so each page holds only its own query and
// data shaping. It replaces the pieces CGS repeats per page: the $.ajax call and
// onRequestError(), allInsightsLoaded, the error dialog and the drill-in dialog state.
//
// Use it from a page:
//   mixins: [insightPageMixin],
//   ...
//   const data = await this.runInsight('GetActivePipelineAnalysisDataSet', query)
//   if (data) this.processInsightData(data)   // `data` is the API's response.data
//
//   this.openDrill({ title, items, columns, mode: 'loans' | 'summary' })
//
// runInsight returns null on failure, and sets `error` to the API's message (CGS's error dialog
// text) for InsightPage to show.

import insightsApi from '@/api/insights.service.js'

export default {
  data() {
    return {
      loading: false,
      error: '',
      header: null,
      drill: { open: false, title: '', items: [], columns: [], mode: 'loans', volumeProp: 'loanamount', exportName: '', showTotals: true, openRows: true },
      insightSeq: 0
    }
  },
  methods: {
    // Only the latest request's answer is used. When someone presses Load twice, the first
    // answer is not drawn over the second.
    async runInsight(action, body, { call } = {}) {
      const seq = ++this.insightSeq
      this.loading = true
      this.error = ''
      try {
        const res = call ? await call() : await insightsApi.insights(action, body)
        if (seq !== this.insightSeq) return null
        if (res && res.isSuccess === false) {
          this.error = res.message || 'Please try again'
          return null
        }
        return res && Object.prototype.hasOwnProperty.call(res, 'data') ? res.data : res
      } catch (e) {
        if (seq !== this.insightSeq) return null
        this.error = e?.message || 'Please try again'
        return null
      } finally {
        if (seq === this.insightSeq) this.loading = false
      }
    },
    onHeader(h) { this.header = h },
    openDrill({ title = '', items = [], columns = [], mode = 'loans', volumeProp = 'loanamount', exportName = '', showTotals = true, openRows = true }) {
      this.drill = { open: true, title, items: Array.isArray(items) ? items : [], columns, mode, volumeProp, exportName, showTotals, openRows }
    },
    closeDrill() { this.drill = { ...this.drill, open: false } }
  }
}
